import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
`;

export const FormSection = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  text-align: center;
`;

export const FormSubtitle = styled.p`
  font-size: 14px;
  color: #999;
  text-align: center;
  margin-top: -12px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  color: #ccc;
  font-weight: 500;
`;

export const Input = styled.input`
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 16px;
  color: #fff;
  transition: border-color 0.2s;

  &::placeholder {
    color: #555;
  }

  &:focus {
    border-color: #e05aad;
  }
`;

export const PhotoUploadArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  touch-action: none;
`;

export const PhotoCircleEdit = styled.div`
  width: 220px;
  height: 220px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #e05aad;
  position: relative;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const PhotoPreviewImg = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin-top: -50%;
  margin-left: -50%;
  pointer-events: none;
  -webkit-user-drag: none;
`;

export const PhotoHint = styled.p`
  font-size: 12px;
  color: #666;
  text-align: center;
`;

export const PhotoPlaceholder = styled.div`
  width: 220px;
  height: 220px;
  border-radius: 50%;
  border: 2px dashed #444;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #666;
  transition: border-color 0.2s;

  &:hover {
    border-color: #e05aad;
    color: #e05aad;
  }

  span {
    font-size: 13px;
  }
`;

export const PhotoControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 4px;
`;

export const ZoomControl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;

  label {
    font-size: 13px;
    color: #888;
    white-space: nowrap;
  }

  input[type='range'] {
    flex: 1;
    accent-color: #e05aad;
    height: 4px;
    -webkit-appearance: none;
    appearance: none;
    background: #333;
    border-radius: 2px;
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #e05aad;
      cursor: pointer;
    }
  }
`;

export const BtnPrimary = styled.button`
  background: linear-gradient(135deg, #e05aad, #f0784a);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const BtnSecondary = styled.button`
  background: transparent;
  color: #ccc;
  border: 1px solid #444;
  border-radius: 12px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s;
  -webkit-tap-highlight-color: transparent;
  white-space: nowrap;

  &:hover {
    border-color: #e05aad;
    color: #e05aad;
  }
`;

/* ===== Preview / Card ===== */

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 420px;
`;

export const CardWrapper = styled.div`
  width: 360px;
  height: 640px;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);

  @media (max-width: 400px) {
    width: 100%;
    height: auto;
    aspect-ratio: 9 / 16;
  }
`;

export const Card = styled.div`
  width: 720px;
  height: 1280px;
  background: linear-gradient(180deg, #1a1418 0%, #110f10 30%, #110f10 100%);
  transform-origin: top left;
  transform: scale(0.5);

  @media (max-width: 400px) {
    transform: scale(calc(100vw / 720 - 0.045));
  }
`;

export const CardContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 50px;
  gap: 0;
`;

export const CardLabel = styled.p`
  font-size: 24px;
  letter-spacing: 6px;
  color: #888;
  text-transform: uppercase;
  margin-bottom: 16px;
  font-weight: 400;
`;

export const CardTitle = styled.h2`
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 16px;
`;

export const CardTech = styled.p`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #e05aad;
  text-align: center;
  margin-bottom: 40px;
`;

export const CardPhotoRing = styled.div`
  width: 340px;
  height: 340px;
  border-radius: 50%;
  padding: 6px;
  background: linear-gradient(135deg, #f0784a, #e05aad, #c13584);
  margin-bottom: 32px;
  flex-shrink: 0;
`;

export const CardPhotoInner = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  background: #222;
  position: relative;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-top: -50%;
    margin-left: -50%;
    pointer-events: none;
    -webkit-user-drag: none;
  }
`;

export const CardName = styled.h3`
  font-size: 56px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
`;

export const CardBadge = styled.div`
  border: 2px solid #444;
  border-radius: 40px;
  padding: 16px 48px;
  margin-bottom: 36px;

  span {
    font-size: 22px;
    letter-spacing: 4px;
    color: #aaa;
    font-weight: 500;
  }
`;

export const CardDivider = styled.div`
  width: 80%;
  height: 1px;
  background: #333;
  margin-bottom: 36px;
`;

export const CardInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  margin-bottom: 24px;
`;

export const CardInfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  span {
    font-size: 22px;
    color: #999;
  }
`;

export const CardFooter = styled.p`
  font-size: 18px;
  letter-spacing: 3px;
  color: #555;
  margin-top: 8px;

  &::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #555;
    margin-right: 10px;
    vertical-align: middle;
  }
`;

export const PreviewActions = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: center;
`;
